import { render, staticRenderFns } from "./DetectivePointsModal.vue?vue&type=template&id=10cccb87&scoped=true&lang=pug&"
import script from "./DetectivePointsModal.vue?vue&type=script&lang=js&"
export * from "./DetectivePointsModal.vue?vue&type=script&lang=js&"
import style0 from "./DetectivePointsModal.vue?vue&type=style&index=0&id=10cccb87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cccb87",
  null
  
)

export default component.exports